export const REACT_APP_API_URL =
  process.env.REACT_APP_API_URL || 'PLACEHOLDER_REACT_APP_API_URL'
export const REACT_APP_COUNTRY =
  process.env.REACT_APP_COUNTRY || 'PLACEHOLDER_REACT_APP_COUNTRY'
export const REACT_APP_BA_URL =
  process.env.REACT_APP_BA_URL || 'PLACEHOLDER_REACT_APP_BA_URL'
export const NODE_ENV = process.env.NODE_ENV
